import { useState, useEffect } from "react";
import { useTranslation } from "next-i18next";

const CookieBanner = () => {
  const [accepted, setAccepted] = useState(false);
  const { t } = useTranslation("common");

  useEffect(() => {
    const isCookieAccepted = localStorage.getItem("cookieAccepted");
    if (isCookieAccepted) {
      setAccepted(true);
    }
  }, []);

  const handleAccept = () => {
    setAccepted(true);
    localStorage.setItem("cookieAccepted", "true");
  };

  if (accepted) {
    return null;
  }

  return (
    // Schmales Band statt Kasten: Auf dem Handy hat der Banner vorher rund
    // 200 px eingenommen und lag über dem Haupt-Knopf — auf einer Seite, die
    // oben ihr Angebot zeigen soll, ist das der teuerste Platz überhaupt.
    // Am Verhalten ändert sich nichts.
    <div className="sticky bottom-0 z-50 border-t border-slate-200/80 bg-white/95 backdrop-blur">
      <div className="mx-auto flex max-w-7xl items-center gap-3 px-4 py-2.5 sm:px-6 lg:px-8">
        <p className="min-w-0 flex-1 text-xs leading-5 text-slate-600">
          {t("cookieText")}
        </p>
        <button
          onClick={handleAccept}
          className="inline-flex flex-none items-center justify-center rounded-full bg-[#FF5744] px-4 py-1.5 text-xs font-semibold text-white shadow-sm transition hover:bg-[#eb4836] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#FF5744]"
        >
          {t("accept")}
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
